<template>
  <div style="width: 100%;">
    <table class="w3-table-all w3-hoverable w3-small w3-right-align elevation-1 DataTable" style="padding: 20px!important; border:none; width: 100%;">
      <tr class="trPrint trHeader">
        <th class="tdData sp" style="width: 160px!important;">שם מפתח</th>
        <th class="tdData" style="width: 160px!important;">ערך מפתח</th>
        <th class="tdData" style="width: 150px!important;"></th>
      </tr>
    </table>
    <div class="scrollContent" v-if="hasData">
      <table class="w3-table-all w3-hoverable w3-small w3-right-align elevation-1" style="border:none;">
        <tr v-for="row in settings" :class="{ 'trSelect': row.selected }">
          <td class="tdData  sp" style="width: 160px!important;">{{row.KeyName}}</td>
          <td class="tdData tdTxt" style="width: 160px!important;" v-show="!isEdit">{{row.KeyValue}}</td>
        </tr>
      </table>
    </div>
    <div fluid v-else>
      <h3 style="padding-top: 40px;">אין נתונים</h3>
    </div>
  </div>
</template>

<script>

  import { db } from '../firebase';
  var settingsRef = db.ref('Settings');

  export default {
    name: 'TableSettings',
    data() {
      return {
        settings: [],
        isEdit: false
      }
    },
    firebase: function () {
      var vm = this;
      return {
        settings: settingsRef.orderByKey()
      }
    },
    created() {
      this.$Log("Vue [TableSettings] is created ...");
    },
    ready() {
      this.$Log("Vue [TableSettings] is ready ...");
    },
    mounted() {
      this.$Log("Vue [TableSettings] is mounted ...");
    },
    updated() {
      this.$Log("Vue [TableSettings] is updated ...");
    },
    computed: {
      hasData() {
        return this.settings != null && this.settings != undefined && this.settings.length > 0;
      },
    },
    methods: {
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// TableSettings.vue?70fa4290